import { round } from "../helpers.js";
import { findBoostedOdds } from "./find-boosted-odds.js";
import { calculateOddsBoost } from "./odds-boost-calculator.js";
const hasBoostedOdds = (boostedOdds, market, eventId) => {
  var _a;
  if (market && Array.isArray(market.outcomes)) {
    const factors = market.outcomes.map((o) => o.odds);
    return (_a = market.outcomes) == null ? void 0 : _a.some((o) => {
      const boostedOdd = findBoostedOdds(boostedOdds, eventId, market.id, o.id, market.specifiers);
      if (boostedOdd) {
        const boostedValues = calculateOddsBoost(
          factors,
          boostedOdd.marginBoost
        );
        return boostedValues.some(
          (v, index) => {
            var _a2;
            return round(v, 2) > ((_a2 = market.outcomes[index]) == null ? void 0 : _a2.odds);
          }
        );
      }
      return false;
    });
  }
  return false;
};
export {
  hasBoostedOdds
};
